"use client";

import { useSEOContent } from "@/providers/seo-content-provider";
import type { PropertyLink } from "@/utils/footer-links";
import { memo } from "react";
import { FooterHybrid } from "./footer/hybrid";

interface FooterWithSEOProps {
	initialLinkColumns?: PropertyLink[][];
}

export const FooterWithSEO = memo(function FooterWithSEO({ initialLinkColumns }: FooterWithSEOProps) {
	const { seoContent } = useSEOContent();
	return <FooterHybrid initialLinkColumns={initialLinkColumns} seoContent={seoContent} />;
});
